import Mustache from "mustache";
import { getLocationsInfo } from "../../api/locationsInfo";

export function initDynamicNearbyLocations(ids) {
  getLocationsInfo(ids)
    .done(function (responseData) {
      const formattedData = responseData.map((item) => {
        let locationTitle = item.location_title.substring(
          item.location_title.indexOf("-") + 1
        );
        locationTitle = locationTitle.trim();
        return {
          ...item,
          location_title: locationTitle,
        };
      });
      mustacheTemplateNearbyLocation(
        formattedData,
        ".js-dynamic-nearby-locations"
      );
    })
    .always(function () {
      $(".show-spinner").removeClass("show-spinner");
    });
}

function mustacheTemplateNearbyLocation(dataToTemplate, selector) {
  var data = {
    locations: [...dataToTemplate],
  };

  var template = [
    "{{#locations}}",
    '<div class="swiper-slide swiper-slide--ns swiper-slide--nb col-md-6 col-lg-4 bg-transparent grid-card" data-test-id="nearby_locations_card_{{counter}}">',
    '<div class="swiper-slide-stretch bg-white grid-card-border grid-card-shadow">',
    '<a class="link-to-all" aria-label="Link to" href="{{location_link}}"></a>',
    '<div class="grid-card-header">',
    '<div class="embed-responsive embed-responsive-3by2">',
    '{{#showTag}}<span class="btn-squared-tag label-tag label-tag-tertiary">{{location_status_text}}</span>{{/showTag}}',
    '<div class="embed-responsive-item" style="background-image: url({{image}})"></div>',
    "</div>",
    "</div>",
    '<div class="grid-card-content">',
    '<div class="grid-card-body">',
    '<h3 class="til-title grid-card-title">{{location_title}}</h3>',
    '{{#address}}<span class="streetAddress">{{address}}</span><br>{{/address}}',
    '{{#inter_location_line_1}}<span class="streetAddress">{{inter_location_line_1}}<br> {{inter_location_line_2}}</span><br>{{/inter_location_line_1}}',
    '{{#city}}<span class="addressLocality">{{city}},</span>{{/city}}',
    '{{#abbr}}<span class="postalCode">{{abbr}} {{zip}}</span><br>{{/abbr}}',
    '{{#country}}<span class="streetAddress">{{country}}</span><br>{{/country}}',
    "</div>",
    '<div class="grid-card-footer text-right">',
    `<span class="btn btn-link-default tertiary-text-color mt-2 font-weight-bold link-underline-thinner" data-test-id="{{location_title}}_link">${window.translate.learn_more}</span>`,
    "</div>",
    "</div>",
    "</div>",
    "</div>",
    "{{/locations}}",
  ].join("\n");

  var html = Mustache.render(template, data);
  var greenTile = $(selector).html();

  $(selector).html(html);

  if ($(selector).find(".swiper-slide").length < 3) {
    $(selector).append(greenTile);
  }
  window.dispatchEvent(new Event("resize"));
}
